import { render } from "./applyForFunding.vue?vue&type=template&id=ecaa35fc&scoped=true"
import script from "./applyForFunding.vue?vue&type=script&lang=js"
export * from "./applyForFunding.vue?vue&type=script&lang=js"

import "./applyForFunding.vue?vue&type=style&index=0&id=ecaa35fc&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecaa35fc"]])

export default __exports__